import { memo } from 'react'

export const TrophyDisabledComponent = () => {
  return (
    <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.0625 43.4375H31.9375"
        className="stroke-signal-red"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 43.4375V33.9375"
        className="stroke-signal-red"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5 25.625C35.5 21.8666 35.4941 15.6329 35.4911 13.75C35.4911 13.4351 35.366 13.133 35.1433 12.9103C34.9206 12.6876 34.6185 12.5625 34.3036 12.5625L17.6942 12.5818C17.3799 12.5818 17.0784 12.7064 16.8558 12.9283C16.6332 13.1502 16.5077 13.4513 16.5067 13.7656C16.5067 16.0352 16.497 23.3524 16.497 25.625C16.497 30.3958 22.6572 33.9375 25.997 33.9375C29.3369 33.9375 35.5 30.3958 35.5 25.625Z"
        className="stroke-signal-red"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 16.125H10.5625V17.3125C10.5625 21.4109 13.0525 25.625 16.5 25.625"
        className="stroke-signal-red"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.5 16.125H41.4375V17.3125C41.4375 21.4109 38.9475 25.625 35.5 25.625"
        className="stroke-signal-red"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="26"
        cy="26"
        r="25.25"
        className="stroke-signal-red"
        strokeWidth="1.5"
      />
      <line
        x1="6.49253"
        y1="41.4478"
        x2="43.4925"
        y2="7.44775"
        className="stroke-signal-red"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export const TrophyDisabled = memo(TrophyDisabledComponent)
